import { sessionPreview } from "./sessionPreview";

// Remove this file when REBRAND_ENABLED is flipped to true. Preview with ?rebrand_enabled=true.

export const rebrandPreviewEnabled = sessionPreview(
  "rebrand_enabled",
  "rebrandPreview",
);
